import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Trophy, Menu, X, Crown } from "lucide-react";
import { Button } from "./ui/button";
import { NAV_LINKS, ROOBET_LINK, SOCIALS } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 350);
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goHome = () => {
    if (location.pathname !== "/") navigate("/");
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#2a2249]/95 backdrop-blur-md border-b border-[#473c7d] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        {/* Logo */}
        <button onClick={goHome} className="flex items-center gap-3 group">
          <img
            src="/assets/broer-logo.png"
            alt="Broer"
            className="h-11 w-11 rounded-full object-cover ring-2 ring-[#edbb23] transition-transform duration-300 group-hover:scale-110"
          />
          <span className="text-2xl font-extrabold tracking-tight text-white">
            BROER
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              className="text-sm font-bold tracking-wide text-[#cfc9e8] hover:text-white transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        {/* Desktop actions */}
        <div className="hidden lg:flex items-center gap-3">
          <button
            onClick={() => scrollTo("#leaderboard")}
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#5b5baf] text-white text-sm font-bold hover:bg-[#5b5baf]/25 transition-colors duration-200"
          >
            <Crown size={16} className="text-[#edbb23]" />
            LEADERBOARD
          </button>
          <a
            href={SOCIALS.discord}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-[#5865F2] hover:bg-[#6b77f5] text-white text-sm font-bold transition-colors duration-200"
          >
            <img src="/assets/discord-white.png" alt="" className="w-4 h-4 object-contain" />
            DISCORD
          </a>
          <a href={ROOBET_LINK} target="_blank" rel="noopener noreferrer">
            <Button className="bg-[#edbb23] hover:bg-[#f4cf52] text-[#251e44] font-extrabold rounded-lg px-5 h-11">
              <img src="/assets/roobet-dark.png" alt="" className="w-4 h-4 mr-1.5 object-contain" /> PLAY NOW
            </Button>
          </a>
        </div>

        {/* Mobile toggle */}
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-xl bg-[#342b60] border border-[#473c7d] p-4 flex flex-col gap-2 animate-fade-up">
          {NAV_LINKS.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              className="text-left px-3 py-2.5 rounded-lg text-sm font-bold text-[#cfc9e8] hover:bg-[#5b5baf]/25 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a href={SOCIALS.discord} target="_blank" rel="noopener noreferrer" className="mt-1">
            <Button className="w-full bg-[#5865F2] hover:bg-[#6b77f5] text-white font-extrabold rounded-lg h-11">
              <img src="/assets/discord-white.png" alt="" className="w-4 h-4 mr-1.5 object-contain" /> DISCORD
            </Button>
          </a>
          <a href={ROOBET_LINK} target="_blank" rel="noopener noreferrer">
            <Button className="w-full bg-[#edbb23] hover:bg-[#f4cf52] text-[#251e44] font-extrabold rounded-lg h-11">
              <img src="/assets/roobet-dark.png" alt="" className="w-4 h-4 mr-1.5 object-contain" /> PLAY NOW
            </Button>
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
